import { useState } from "react";

import {
    createDestinationMetaCustomAudience,
    createDestinationTiktokCustomAudience,
    createExternalTiktokCustomAudience,
    createMetaCustomAudience,
} from "helpers/destinations/createDestination";

/** Meta (fbca) and TikTok (ttca) custom audience creation. */
const useCustomAudienceDestination = ({
    setIsButtonLoader,
    createDestinationAction,
}) => {
    const [metaInfos, setMetaInfos] = useState(null);
    const [tiktokInfos, setTiktokInfos] = useState(null);

    const createMeta = async () => {
        const {
            name,
            showAdAccountSelect,
            ad_account_id,
            custom_audience_id,
            custom_audience_name,
            partner_install_id,
            retention_days,
            strategy,
        } = metaInfos;
        setIsButtonLoader(true);
        try {
            const response = showAdAccountSelect
                ? await createDestinationMetaCustomAudience({
                      ad_account_id,
                      custom_audience_id,
                      custom_audience_name,
                      partner_install_id,
                      data_sender_method: strategy,
                  })
                : await createMetaCustomAudience({
                      name,
                      retention_days,
                      partner_install_id,
                      ad_account_id,
                      data_sender_method: strategy,
                  });
            await createDestinationAction(response);
        } finally {
            setIsButtonLoader(false);
        }
    };

    const createTiktok = async () => {
        const {
            advertiser_id,
            custom_audience_id,
            custom_audience_name,
            retention_days,
            data_sender_method,
            file,
            isCreatingNew,
        } = tiktokInfos;

        setIsButtonLoader(true);
        try {
            let response;
            if (isCreatingNew) {
                const formData = new FormData();
                formData.append("advertiser_id", advertiser_id);
                formData.append("custom_audience_name", custom_audience_name);
                formData.append("retention_days", retention_days);
                formData.append("data_sender_method", data_sender_method);
                if (file) formData.append("file", file);
                response = await createExternalTiktokCustomAudience(formData);
            } else {
                response = await createDestinationTiktokCustomAudience({
                    advertiser_id,
                    custom_audience_id,
                    custom_audience_name,
                    retention_days,
                    data_sender_method,
                });
            }
            await createDestinationAction(response);
        } finally {
            setIsButtonLoader(false);
        }
    };

    const reset = () => {
        setMetaInfos(null);
        setTiktokInfos(null);
    };

    return {
        setMetaInfos,
        setTiktokInfos,
        createMeta,
        createTiktok,
        reset,
    };
};

export default useCustomAudienceDestination;
